<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1385_19104)">
<path d="M14.0002 4H10.0002C9.6315 4 9.3335 4.298 9.3335 4.66667C9.3335 5.03533 9.6315 5.33333 10.0002 5.33333H13.7242L9.3495 9.708C8.9735 10.084 8.3615 10.084 7.98483 9.708L6.29217 8.01533C5.39617 7.11933 3.93817 7.11933 3.04217 8.01533L0.1955 10.862C-0.0651667 11.1227 -0.0651667 11.544 0.1955 11.8047C0.3255 11.9347 0.496167 12 0.666833 12C0.8375 12 1.00817 11.9347 1.13817 11.8047L3.98483 8.958C4.3495 8.59333 4.98483 8.59333 5.3495 8.958L7.04217 10.6507C7.93817 11.5467 9.39617 11.5467 10.2922 10.6507L14.6675 6.276V10C14.6675 10.3687 14.9655 10.6667 15.3342 10.6667C15.7028 10.6667 16.0008 10.3687 16.0008 10V6C16.0008 4.89733 15.1028 4 14.0002 4Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_1385_19104">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
